import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { Disable2FA } from '@/modules/profile/types'
import { disable2FA } from '../../services'
import { ProfileMutationKey } from '@/modules/profile/keys'

export default function useMutationDisable2FA(
	id: string,
	props?: UseBaseMutationOptions<void, Disable2FA>,
) {
	return useMutation({
		mutationKey: [ProfileMutationKey.Disable2FA, id],
		mutationFn: (params) => disable2FA(id, params),
		...props,
	})
}
